import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss']
})
export class CountDownTimerComponent implements OnInit, OnDestroy, AfterViewInit {

  private subscription: Subscription;
  @Input()
  resetTimer: boolean;

  @Output() countdownEnded = new EventEmitter<boolean>();

  public dateNow = new Date();
  public dDay = new Date('Jan 01 2021 00:00:00');
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute = 300;

  public timeDifference;
  public secondsToDday = 0;
  public minutesToDday;
  public hoursToDday;
  public daysToDday;


  private getTimeDifference() {
    this.secondsToDday--;
    if (this.secondsToDday === 0) {
      this.countdownEnded.emit(true);
    }
  }
  ngOnInit(): void {
    this.secondsToDday = this.SecondsInAMinute;
  }

  ngAfterViewInit(): void {
    console.log('reset');
    
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
    this.subscription = interval(1000)
      .subscribe(x => { this.getTimeDifference(); });
  }
  ngOnDestroy() {
    console.log('destroy');
    this.secondsToDday = 0;
    this.subscription.unsubscribe();
  }

}
